const TimerUnit = ({ value, label }) => (
  <div className="bg-white border border-gray-100 p-4 sm:p-6 rounded-[2rem] shadow-sm transform hover:scale-105 transition-transform">
    <div className="text-2xl sm:text-3xl font-black text-teal-600 mb-1">
      {String(value).padStart(2, '0')}
    </div>
    <div className="text-[9px] font-black text-gray-400 uppercase tracking-widest">
      {label}
    </div>
  </div>
);

const CountdownTimer = ({ timeLeft }) => {
  return (
    <div className="mt-12 grid grid-cols-4 gap-3 sm:gap-6 max-w-lg w-full">
      <TimerUnit value={timeLeft.days} label="Days" />
      <TimerUnit value={timeLeft.hours} label="Hours" />
      <TimerUnit value={timeLeft.minutes} label="Min" />
      <TimerUnit value={timeLeft.seconds} label="Sec" />
    </div>
  );
};

export default CountdownTimer;
